module.exports = __webpack_public_path__ + "static/img/icon7.c2e7b50b.png";